import { Component, OnInit, Input, Output, EventEmitter,Renderer2 } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { forkJoin, timer } from 'rxjs';
import { take } from 'rxjs/operators';
import { Investor } from 'src/app/models/investor';
import { InvestorAccount } from 'src/app/models/investor-account';
import { InvestorDetails } from 'src/app/models/investor-details';
import { OnboardingService } from 'src/app/services/rest/onboarding.service';
import { UtilsService } from 'src/app/utils/utils.service';
import { SharedService } from 'src/app/services/shared/shared.service';
import { CaptchaService } from 'src/app/services/captcha/captcha.service';

/** otp verification  */
@Component({
  selector: 'app-otp-verify',
  templateUrl: './otp-verify.component.html',
  styleUrls: ['./otp-verify.component.scss']
})
export class OtpVerifyComponent implements OnInit {

  /** Form Group for Holding the form Controls*/
  formGroup: FormGroup;
  /** Investor DTO for holding Investor Data*/
  investor: Investor;
  /** Object holding the route info and its methods*/
  routeInfo: any;
  /** String specifiying the current Business Unit*/
  businessInfo: string;
  /** Configuration for component*/
  config: any;
  /**FormValues input to component */
  @Input('formValues') formValues;
  /**FormValues input to component */
  @Input('actionButtons') actionButtons;
  /** Output event emitter on Submission*/
  @Output('onActionClicked') onActionClicked: EventEmitter<any>;
  /** current url */
  currentUrl: string;
  /** contact Updation Type */
  @Input('contactUpdationType') contactUpdationType: string;
  /** abort Controller */
  private abortController : any;
/**
 * initial component call
 * @param formBuilder FormBuilder
 * @param rest OnboardingService
 * @param utils UtilsService
 * @param shared SharedService
 * @param captcha CaptchaService
 * @param renderer Renderer2
 */
  constructor(private formBuilder: FormBuilder, private rest: OnboardingService, public utils: UtilsService,public shared:SharedService,private captcha: CaptchaService,    private renderer: Renderer2) {
    this.onActionClicked = new EventEmitter<any>();
    this.investor = this.utils.getOnboardingData();
    this.businessInfo = this.utils.getBusinessUnit();
    this.config = { mobileVerified: false, emailVerified: false, maxTime: 30 };
    this.config.isReferCodeHidden = (this.utils.getSource() || '').toLowerCase() == 'thirdparty' && this.utils.getReferCode();
    this.routeInfo = this.utils.getRouteInfo('otp-popup');
    this.currentUrl = location.href;
    this.initializeForm();
  }

  /** Life Cycle hook  after initialized all data-bound properties */
  ngOnInit() {
    this.config.getMobileOtp = window.location.pathname.indexOf("/onboard")>-1 ? true:false
    this.captcha.initiateCaptchaScript(this.renderer);
    let otpConfig = this.utils.getOtpConfig() || {};
    let investorDetails = (this.investor.investorDetailsDtoList || [])[0] || new InvestorDetails();
    let investorAccountDetails = (this.investor.investorAccountDetailsDtoList || [])[0] || new InvestorAccount();
    this.config.mobileVerified = (investorAccountDetails.isMobileVerified != 'Y') ? false : true;
    this.config.emailVerified = (investorAccountDetails.isEmailVerified != 'Y') ? false : true;
    this.verifyForm(this.formValues);
  }

  /** Method to Initialize Form */
  initializeForm() {
    let inputs = this.routeInfo.inputs;
    this.formGroup = this.formBuilder.group({
      mobOtp: new FormControl('', inputs.mobOtp.validations || inputs.mobOtp[this.businessInfo + 'Validators']),
      emailOtp: new FormControl('', inputs.emailOtp.validations || inputs.emailOtp[this.businessInfo + 'Validators'])
    });
  }
/**
 * verify otp
 * @param values passing otp
 */
  verifyForm(values: any) {
    this.investor = this.utils.getOnboardingData();
    let investorDetails = (this.investor.investorDetailsDtoList || [])[0] || new InvestorDetails();
    
    let investorAccountDetails = (this.investor.investorAccountDetailsDtoList || [])[0] || new InvestorAccount();
    this.config.isMobileNotVerified = !investorDetails.mobileNum || values.mobileNumber != investorDetails.mobileNum || investorAccountDetails.isMobileVerified != 'Y';
    this.config.isEmailNotVerified = !investorDetails.emailID || values.email != investorDetails.emailID || investorAccountDetails.isEmailVerified != 'Y';
    if (this.utils.otpFormModal.otpGenerated) {
      this.setOTPTimer(this.config.isMobileNotVerified, this.config.isEmailNotVerified)
    } else if (this.config.isEmailNotVerified || this.config.isMobileNotVerified) {
      this.sendOnboardOTP(this.config.isMobileNotVerified ? values.mobileNumber : null, this.config.isEmailNotVerified ? values.email : null, false);
    } else if (!(this.config.isEmailNotVerified && this.config.isMobileNotVerified)) {
      this.shared.setOtpStatus({ investor: this.investor, verified: true, action: 'submit' })
      this.onActionClicked.emit({ investor: this.investor, verified: true, action: 'submit' });
    
    }

  }
  /**
   *  set timer 30 sec
   * @param isMobile boolean value for mobile 
   * @param isEmail  boolean value for email
   */
  setOTPTimer(isMobile?: boolean, isEmail?: boolean) {
    if (isMobile) {
      this.config.mobSubscription = timer(0, 1000).pipe(take(this.config.maxTime)).subscribe((value) => {
        this.config.mobValue = this.config.maxTime - (value);
      })
    }
    if (isEmail) {
      this.config.emailSubscription = timer(0, 1000).pipe(take(this.config.maxTime)).subscribe((value) => {
        this.config.emailValue = this.config.maxTime - (value);
      })
    }

  }
/**
 * for sending onboarding otp
 * @param mobile passing mobile number
 * @param email passing email
 * @param isResend boolean value for resend or not
 */
 async sendOnboardOTP(mobile?: string, email?: string, isResend?: boolean) {
   
  let forkList: any = {};
  let otpConfig = this.utils.getOtpConfig() || {};
  let investorAccountDetails = (this.investor.investorAccountDetailsDtoList || [])[0] || new InvestorAccount();
  let token: any ;
  if(mobile){
    token ? this.captcha.removeCaptchaScript(this.renderer) : ""
    token = await this.captcha.checkCaptcha();
    let mobilePayload = {
      mobileNumber: parseInt(mobile),
      otpType : isResend ? "Resend":"",
      investorId: this.investor.id,
      ssoSubjectId: this.investor.investorAccountDetailsDtoList[0].ssoSubjectId || '',
      purpose: "mobile",
      captcha_resp: token,
      old_session_id:this.config.mobileOTPReference
    }
    mobile && (investorAccountDetails.isMobileVerified == 'N' || this.config.isMobileNotVerified) ? forkList.mobile = this.rest.sendOnboardOTP(mobilePayload,this.utils.getOriginalSource().trim()==='ALPHABEE',this.investor.id) : '';
  }
   
    if(email){
      token ? this.captcha.removeCaptchaScript(this.renderer) : ""
      token = await this.captcha.checkCaptcha();

    let  emailPayload = {
      email: email,
      otpType : isResend ? "Resend":"",
      investorId: this.investor.id,
      ssoSubjectId: this.investor.investorAccountDetailsDtoList[0].ssoSubjectId || '',
      purpose: "email",
      captcha_resp: token,
      old_session_id: this.config.emailOTPReference
    }
    email && (investorAccountDetails.isEmailVerified == 'N' || this.config.isEmailNotVerified) ? forkList.email = this.rest.sendOnboardOTP(emailPayload,this.utils.getOriginalSource().trim()==='ALPHABEE',this.investor.id) : '';
   }
   
    

    
    forkJoin(forkList).subscribe((res: any) => {

    
      

      let message = 'OTP has been ' + (isResend ? ' resent ' : 'sent ') + 'on given '
      if (forkList.mobile && res && res.mobile && res.mobile.Body) {
        let mobileRes = res.mobile.Body;
        if(isResend){
           message= 'You will soon receive OTP given Mobile Number'
        }else{
          message += 'Mobile Number'
        }
        this.config.mobileOTPReference = mobileRes.sessionId;
      }
       if (forkList.email && res && res.email && res.email.Body) {
        let emailRes = res.email.Body;
         if((message.indexOf('Mobile Number') > -1)&&isResend){
            message+=' and an OTP on Email Address'
         }else{
          message += ((message.indexOf('Mobile Number') > -1 ? ' and' : '') + ' Email Address');
         }
      
        this.config.emailOTPReference = emailRes.sessionId;
      }
      this.utils.setOtpConfig({ mobileOTPReference: this.config.mobileOTPReference || otpConfig.mobileOTPReference || '', emailOTPReference: this.config.emailOTPReference || otpConfig.emailOTPReference || '' });
      message += '. Kindly check';
      if (message.indexOf('Mobile Number') > -1 || message.indexOf('Email Address') > -1) {
        this.utils.success('Success', message);
        this.utils.setOtpConfig({ otpGenerated: true })
        if (!isResend) {
          this.config.otpForm = true;
        }
        this.setOTPTimer(forkList.mobile, forkList.email);
      } else {
        this.utils.error(
          "Attention!!",
          res.Message ? res.Message  :
            "Something went wrong from our end. Please try again"
        );
      }
    }, (err) => {
      this.utils.error(
        "Attention!!",
        err.error.Message ? err.error.Message + " For Mobile Number" :
          "Something went wrong from our end. Please try again"
      );
    });
  }

  /**
   * verification OTP
   * @param mobileOtp passing mobile otp
   * @param emailOtp passing email otp
   * @param proceed sumbit basis
   */
  verifyOTP(mobileOtp?: string, emailOtp?: string,proceed?) {
    if (!this.contactUpdationType) {
      if (mobileOtp && emailOtp && !this.config.mobileVerified && !this.config.emailVerified) {
        this.contactUpdationType = 'both';
      } else if (mobileOtp && !this.config.mobileVerified) {
        this.contactUpdationType = 'mobile';
      } else {
        this.contactUpdationType = 'email';
      }
    }
  
   
    let otpConfig = this.utils.getOtpConfig();
    let forkList: any = {};
    this.investor = this.utils.getOnboardingData();
    let message = '';
    if(mobileOtp && !this.config.mobileVerified){
      let payload={
        sessionId : this.config.mobileOTPReference||otpConfig.mobileOTPReference,
        otp : mobileOtp
      }
      this.rest.verifyOnboardOTP(payload, this.investor.id).subscribe((res:any)=>{
        if(res && res.Body !== null && typeof res.Body === 'object' && Object.keys(res.Body).length > 0){
        // let mobileRes = res.Body;
        this.config.mobileVerified = true;
        this.investor.investorAccountDetailsDtoList[0].isMobileVerified = 'N';
        this.investor.investorDetailsDtoList[0].mobileOtp = null;
        this.investor.investorAccountDetailsDtoList[0].isMobileVerified = this.config.mobileVerified ? 'Y' : 'N';
        this.investor.investorDetailsDtoList[0].mobileOtp = mobileOtp;
        this.investor.investorDetailsDtoList[0].mobileNum = this.config.mobileVerified ? this.formValues.mobileNumber : this.investor.investorDetailsDtoList[0].mobileNum;        
        this.utils.updateOnboardingData(this.investor);
        this.utils.setOtpConfig({ 'emailVerified': this.config.emailVerified, 'mobileVerified': this.config.mobileVerified, contactUpdationType: this.contactUpdationType });
        if (this.investor.investorAccountDetailsDtoList[0].isMobileVerified == 'Y' && this.investor.investorAccountDetailsDtoList[0].isEmailVerified == 'Y') {
          this.utils.removeOtpConfig();
          this.shared.setOtpStatus({ investor: this.investor, verified: true, action: 'submit',proceed:proceed })
          this.onActionClicked.emit({ investor: this.investor, verified: true, action: 'submit', contactUpdationType: this.contactUpdationType });
        }

        }else{
          this.utils.error(
            "Attention!!",
            res.Message ? res.Message  :
              "Something went wrong from our end. Please try again"
          );
         
          this.config.mobileVerified = false;
        }
        

      }, (err) => {
        this.utils.error(
          "Attention!!",
          err.error.Message ? err.error.Message + " For Mobile Number" :
            "Something went wrong from our end. Please try again"
        );
        message = 'Invalid or expired OTP for mobile number';
        this.config.mobileVerified = false;
      })

    }
    if(emailOtp && !this.config.emailVerified){
      let emailpayload ={
        sessionId : this.config.emailOTPReference||otpConfig.emailOTPReference,
        otp : emailOtp
      }
      this.rest.verifyOnboardOTP(emailpayload,this.investor.id).subscribe((res:any)=>{
        if(res && res.Body !== null && typeof res.Body === 'object' && Object.keys(res.Body).length > 0){
          let emailRes = res.Body;
        this.config.emailVerified = true;
        this.investor.investorAccountDetailsDtoList[0].isEmailVerified = 'N';
        this.investor.investorDetailsDtoList[0].emailOtp = null;
        this.investor.investorAccountDetailsDtoList[0].isEmailVerified = this.config.emailVerified ? 'Y' : 'N';
        this.investor.investorDetailsDtoList[0].emailOtp = emailOtp;
        this.investor.investorDetailsDtoList[0].emailID = this.config.emailVerified ? this.formValues.email : this.investor.investorDetailsDtoList[0].emailID;

        this.utils.updateOnboardingData(this.investor);
        this.utils.setOtpConfig({ 'emailVerified': this.config.emailVerified, 'mobileVerified': this.config.mobileVerified, contactUpdationType: this.contactUpdationType });
        if (this.investor.investorAccountDetailsDtoList[0].isMobileVerified == 'Y' && this.investor.investorAccountDetailsDtoList[0].isEmailVerified == 'Y') {
          this.utils.removeOtpConfig();
          this.shared.setOtpStatus({ investor: this.investor, verified: true, action: 'submit',proceed:proceed })
          this.onActionClicked.emit({ investor: this.investor, verified: true, action: 'submit', contactUpdationType: this.contactUpdationType });
        }

        }else{
          this.utils.error(
            "Attention!!",
            res.Message? res.Message :
              "Something went wrong from our end. Please try again"
          );
       
          this.config.emailVerified = false;
      
        }
        
  

      }, (err) => {
        this.utils.error(
          "Attention!!",
          err.error.Message? err.error.Message + " For Email address":
            "Something went wrong from our end. Please try again"
        );
        message += ((!this.config.mobileVerified) ? ' and email' : 'Invalid or expired OTP for email address');
        this.config.emailVerified = false;
      })

      

    } 

     
     
   
    // forkJoin(forkList).subscribe((res: any) => {
    //   let message = '';
    //   if(mobileOtp){
    //     let mobileRes = res.mobile.Body;
    //     this.config.mobileVerified = true;
    //     if (forkList.mobile && typeof mobileRes != 'boolean' && (mobileRes.error || mobileRes.errorCode)) {
    //       message = 'Invalid or expired OTP for mobile number';
    //       this.config.mobileVerified = false;
    //       if (forkList.mobile && typeof mobileRes != 'boolean' && (mobileRes.error || mobileRes.errorCode)) {
    //         message = 'Invalid or expired OTP for mobile number';
    //         this.config.mobileVerified = false;
    //       }
    //     }

    //     this.investor.investorAccountDetailsDtoList[0].isMobileVerified = 'N';
    //     this.investor.investorDetailsDtoList[0].mobileOtp = null;
    //     this.investor.investorAccountDetailsDtoList[0].isMobileVerified = this.config.mobileVerified ? 'Y' : 'N';
    //     this.investor.investorDetailsDtoList[0].mobileOtp = mobileOtp;
    //     this.investor.investorDetailsDtoList[0].mobileNum = this.config.mobileVerified ? this.formValues.mobileNumber : this.investor.investorDetailsDtoList[0].mobileNum;        
    //   }
    //   if(emailOtp){
    //     let emailRes = res.email.Body;
    //     this.config.emailVerified = true;
    //     if (forkList.email && typeof emailRes != 'boolean' && (emailRes.error || emailRes.errorCode)) {
    //       message += ((forkList.mobile && !this.config.mobileVerified) ? ' and email' : 'Invalid or expired OTP for email address');
    //       this.config.emailVerified = false;
    //     }
    //     this.investor.investorAccountDetailsDtoList[0].isEmailVerified = 'N';
    //     this.investor.investorDetailsDtoList[0].emailOtp = null;
    //     this.investor.investorAccountDetailsDtoList[0].isEmailVerified = this.config.emailVerified ? 'Y' : 'N';
    //     this.investor.investorDetailsDtoList[0].emailOtp = emailOtp;
    //     this.investor.investorDetailsDtoList[0].emailID = this.config.emailVerified ? this.formValues.email : this.investor.investorDetailsDtoList[0].emailID;
    //   }
      
    //   message ? this.utils.error('Error!!', message) : '';
     
     
    //   this.utils.updateOnboardingData(this.investor);
    //   this.utils.setOtpConfig({ 'emailVerified': this.config.emailVerified, 'mobileVerified': this.config.mobileVerified, contactUpdationType: this.contactUpdationType });
    //   if (this.investor.investorAccountDetailsDtoList[0].isMobileVerified == 'Y' && this.investor.investorAccountDetailsDtoList[0].isEmailVerified == 'Y') {
    //     this.utils.removeOtpConfig();
    //     this.shared.setOtpStatus({ investor: this.investor, verified: true, action: 'submit',proceed:proceed })
    //     this.onActionClicked.emit({ investor: this.investor, verified: true, action: 'submit', contactUpdationType: this.contactUpdationType });
      
    //   }
    // }, (err) => {
    //   this.utils.error(
    //     "Attention!!",
    //     err.error.Message ||
    //       "Something went wrong from our end. Please try again"
    //   );
    // });
  }
/** cancel otp verification */
  cancelOTPVerify() {
    this.shared.setOtpStatus({ investor: this.investor, verified: false, action: 'cancel' })
    this.onActionClicked.emit({ investor: this.investor, verified: false, action: 'cancel', contactUpdationType:this.contactUpdationType });
    this.utils.setOtpConfig({ isHidden: true, isSkip: false });
  }
/** skip form */
  skipForm() {
    if(this.investor.investorDetailsDtoList[0].dateOfBirth)
      if(sessionStorage.getItem('isBelow25') === 'true'){
        this.utils.pushDataLayerEvent({
          'event': 'details_do_later_with_below25',
          'platform': window.innerWidth < 767 ? 'mobileweb' : 'desktopweb',
          'page_path': window.location.pathname,
          'page_url': window.location.href,
          'userId': this.utils.generateSHA256Hash(this.investor.investorDetailsDtoList[0].mobileNum.toString()),
          'lead_source':this.investor.investorAccountDetailsDtoList[0].originalSource.toLowerCase() || "website",
          'phone': this.utils.generateSHA256Hash(this.investor.investorDetailsDtoList[0].mobileNum),
          'custom_source': sessionStorage.getItem('custom_source') || "",
          'custom_medium': sessionStorage.getItem('custom_medium') || "",
          'custom_campaign': sessionStorage.getItem('custom_campaign') || ""
        })
      }else{
        this.utils.pushDataLayerEvent({
          'event': 'details_do_later',
          'platform': window.innerWidth < 767 ? 'mobileweb' : 'desktopweb',
          'page_path': window.location.pathname,
          'page_url': window.location.href,
          'userId': this.utils.generateSHA256Hash(this.investor.investorDetailsDtoList[0].mobileNum.toString()),
          'lead_source':this.investor.investorAccountDetailsDtoList[0].originalSource.toLowerCase() || "website",
          'phone': this.utils.generateSHA256Hash(this.investor.investorDetailsDtoList[0].mobileNum),
          'custom_source': sessionStorage.getItem('custom_source') || "",
          'custom_medium': sessionStorage.getItem('custom_medium') || "",
          'custom_campaign': sessionStorage.getItem('custom_campaign') || ""
        })
      }
    this.shared.setOtpStatus({ investor: this.investor, verified: false, action: 'skip' })
    this.onActionClicked.emit({ investor: this.investor, verified: false, action: 'skip' });
 
    this.utils.setOtpConfig({ isHidden: true, isSkip: true });
    // this.utils.info('Skipping for Now', 'You can enter OTP anytime before completing just by clicking OTP button in bottom right');
    this.utils.info('Skipping for Now', 'You can enter OTP before submission of onboarding application');
  }

  /** Life Cycle hook  Cleanup just before Angular destroys the directive/component */
  ngOnDestroy(): void {
    this.contactUpdationType = '';
    if (this.abortController) {
      this.abortController.abort();
    }
  }
/**  invoked immediately after Angular has completed initialization of a component's view.*/
  ngAfterViewInit() {
    this.fetchOTP();
  }
/**  fetching  otp value*/
  async fetchOTP() {
    if ('OTPCredential' in window) {
      this.abortController = new AbortController();
      await navigator.credentials.get({
        otp: { transport: ['sms'] },
        signal: this.abortController.signal
      }).then(otp => {
        let otpObj: any;
        otpObj = otp;
        if (this.formGroup && this.formGroup.get('mobOtp') && otpObj && otpObj.code) {
          this.formGroup.get('mobOtp').patchValue(otpObj.code);
        }
        // ac.abort();
      }).catch(err => {
        console.log(err, "error");
        // ac.abort();
      });
    }
  }



}
